module.exports = __webpack_public_path__ + "crm_static/img/sgif_bg2@3x.23bd92ba.png";